const formatDate = (dateString) => {
    if (!dateString) return "";
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ""; // Handle invalid dates
  
    return date.toLocaleDateString("he-IL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  
  const datesHelper = {
    formatDate,
  };
  
  export default datesHelper;
  